import { rd } from '@passionware/monads';
import { MergeServices } from 'v5/platform/ts/services';
import { WithAccessService } from 'v5/services/front/AccessService/AccessService';
import { Permission } from 'v5/services/front/PermissionService/PermissionService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { WithSystemSettingsService } from './SystemSettingsService';

/**
 * Tag inputs may offer "Create tag" only when the browsing scope's
 * `tags_fixed` is off and the user may configure tags; still loading counts
 * as not allowed.
 */
export function useTagCreationAllowed(
  services: MergeServices<
    [WithAppScopeService, WithSystemSettingsService, WithAccessService]
  >
): boolean {
  const identity = services.appScopeService.useResolvedScopeIdentity();
  const tagsFixed = rd.tryGet(
    services.systemSettingsService.useSetting(identity, 'tags_fixed')
  )?.value;
  const canConfigureTags = rd.tryGet(
    services.accessService.useCan(identity)({
      action: Permission.CONFIGURE_TAGS
    })
  );
  return tagsFixed === false && canConfigureTags === true;
}
